<div class="step-two-col">
  <div class="step-col-main">
    <div class="action-panel summary-panel pmeeting-panel">
      <div class="action-panel-header pmeeting-header" (click)="opened = !opened" style="cursor:pointer;">
        <i class="fa fa-clipboard" style="margin-right:6px;"></i>
        <span *ngIf="!data['user']">Summary</span>
        <span *ngIf="data['user'] == 'epe'">Expert's survey summary</span>
        <span *ngIf="data['user'] == 'project'">Project's survey summary</span>
        <i class="fa pmeeting-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>

      <div *ngIf="opened" class="action-panel-body">
        <div class="summary-list" *ngIf="summary && objectKeys(summary).length > 0">
          <div class="summary-row" *ngFor="let key of getKeys()">
            <div class="summary-key">{{ humanizeKey(key) }}</div>
            <div class="summary-val">
              <i *ngIf="summary[key] === true" class="fa fa-check"></i>
              <span *ngIf="summary[key] !== true">
                <div [innerHTML]="summary[key]"></div>
              </span>
            </div>
          </div>
        </div>
        <p *ngIf="(!summary || objectKeys(summary).length == 0) && data['form'] == 'survey'"
           class="text-muted" style="margin:0;font-style:italic;">
          The {{ data['user'] }}'s survey is not ready yet.
        </p>
        <p *ngIf="(!summary || objectKeys(summary).length == 0) && data['form'] != 'survey'"
           class="text-muted" style="margin:0;font-style:italic;">
          The meeting has been skipped.
        </p>
      </div>
    </div>

    <!-- Project meeting / advice feedback (project + admins) -->
    <ng-container *ngIf="auth.isProject() || auth.isAdmin() || auth.isProjectBoard() || auth.isCallManager()">
      <survey-project-meeting *ngIf="surveyKind === 'meeting' && surveyStep > 0" [step]="surveyStep"></survey-project-meeting>
      <survey-project-advice *ngIf="surveyKind === 'advice'"></survey-project-advice>
    </ng-container>
  </div>
  <div class="step-col-report" *ngIf="report">
    <report></report>
  </div>
</div>

<svg class="inline-svg">
  <symbol id="check" viewBox="0 0 12 10">
    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
  </symbol>
</svg>
